export enum LanguageActionType {
  LoadLanguages                           = 'LOAD_LANGUAGES',
  LoadLanguagesCompleted                  = 'LOAD_LANGUAGES_COMPLETED',
  LoadLanguagesFailed                     = 'LOAD_LANGUAGES_FAILED',
}
